class Tabs {

    constructor(id) {
        this._element = $(id);
        this._triggers = {};
        this._tabs = {};

        let tabs = this._element.children(".tab");
        this._active = this._element.find(".active:first");

        // Process relevant tabs in set
        let self = this;
        tabs.each((i, e) => {
            let tab = $(e);
        })
    }

    add(title, object) {
        let self = this;

        let obj = { title, data: object };
        let tab = $("<div>", { class: "tab" });

        this._tabs[tab] = obj;

        tab.text(title);
        tab.on('click', () => {

            // Make tab active
            tab.addClass("active");

            // Remove active status, and reassign
            this._active.removeClass("active");
            this._active = tab;

            // TODO: Callback here
            self.trigger("change", obj);
        });

        //
        this._element.append(tab);
        return tab;
    }

    select(tab) {

        // Make tab active
        tab.addClass("active");

        // Remove active status, and reassign
        this._active.removeClass("active");
        this._active = tab;

        let obj = this._tabs[tab];

        // TODO: Callback here
        this.trigger("change", obj);
    }

    on(event, callback) {
        // Ensure list
        if (event in this._triggers === false)
            this._triggers[event] = []

        // Append list
        this._triggers[event].push(callback);
    }

    trigger(event, ...args) {
        if (event in this._triggers) {
            for (let ev of this._triggers[event]) {
                ev(...args);
            }
        }
    }
}

// // For each tab container
// $(".tab").parent().each((i, e) => {
//     let tabs = new Tabs(e);
// })

export default Tabs;